'use strict';

var tslib_es6 = require('../../_virtual/tslib.es6-c0cde917.js');
var React = require('react');
var classNames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

/**
 * Loader block component used to indicate loading state.
 *
 * Based on http://fandomdesignsystem.com/#/components/progress-indicators
 */
const Spinner = (_a) => {
    var { className, size = 30, stroke = 2, block = false, inline = false } = _a, rest = tslib_es6.__rest(_a, ["className", "size", "stroke", "block", "inline"]);
    const r = (Number(size) - Number(stroke)) / 2;
    const translate = r + Number(stroke) / 2;
    const dash = 2 * Math.PI * r;
    return (React__default["default"].createElement("div", Object.assign({ className: classNames__default["default"]('fandom-spinner', { 'is-block': block, 'is-inline': inline }, className), style: {
            width: size,
            height: size,
        } }, rest),
        React__default["default"].createElement("svg", { width: size, height: size, viewBox: `0 0 ${size} ${size}`, xmlns: "http://www.w3.org/2000/svg" },
            React__default["default"].createElement("g", { transform: `translate(${translate}, ${translate})` },
                React__default["default"].createElement("circle", { fill: "none", strokeWidth: stroke, strokeDasharray: dash, strokeDashoffset: dash, strokeLinecap: "round", r: r })))));
};

module.exports = Spinner;
